// @ts-nocheck
import cx from 'helpers/cx'

import styles from './SubmenuWrapper.module.css'

const SubmenuWrapper = ({
    $showSubItems,
    $isSubSubmenu,
    className,
    ...rest
}) => (
    <li
        className={cx(
            styles.wrapper,
            $showSubItems && styles.showSubItems,
            className,
        )}
        data-sub-submenu={$isSubSubmenu ? 'true' : undefined}
        {...rest}
    />
)

export default SubmenuWrapper
